<div class="flex checkbox" (click)="$event.stopPropagation()">
  <input type="checkbox" id="box-{{index}}" [formControl]="control">
  <label for="box-{{index}}"></label>
</div>
